import { Button, Layout, theme } from "antd";
import Title from "antd/es/typography/Title";
import { LogoutOutlined } from "@ant-design/icons";
import { useContext } from "react";
import { AuthContext } from "$context/AuthContextProvider";
const { Header, Content, Footer } = Layout;

const App = ({ content }) => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const authContext = useContext(AuthContext);
  return (
    <Layout>
      <Header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Title level={3} style={{ color: "white" }}>
          AVAG Calendar tool
        </Title>

        <Button
          type="primary"
          icon={<LogoutOutlined />}
          onClick={() => {
            authContext.logout();
          }}
        >
          Logout
        </Button>
      </Header>
      <Content
        style={{
          padding: "0 48px",
        }}
      >
        <div
          style={{
            padding: 24,
            minHeight: 380,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          {content}
        </div>
      </Content>
      <Footer
        style={{
          textAlign: "center",
        }}
      >
        Ant Design ©{new Date().getFullYear()} Created by Ant UED
      </Footer>
    </Layout>
  );
};
export default App;
